<div class="grid-6 margin-0">
	<!-- 1. Entity information -->
	<div class="grid-column-one-full card-info-block">
		<div class="card-content-title">
			<b translate>eoffer.wizard.header.entity.information</b>
		</div>
		<div class="card-content-block">
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>offers.create.details.customer.offer-name</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.rfqRef">
						{{displayedOfferHeader.rfqRef}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.header.customer</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.soldTo">
						{{displayedOfferHeader.soldTo}}</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>application.procurement.supplier.rfqNumber</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.referenceAm">
						{{displayedOfferHeader.referenceAm}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.wizard.delivery.address</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.shipTo">
						{{displayedOfferHeader.shipTo}}</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.header.last.update.date</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.lastModificationDate">
						{{displayedOfferHeader.lastModificationDate}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.enduser</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.endUser">
						{{displayedOfferHeader.endUser}}</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 2. Terms Informations -->
	<div class="grid-column-one-full card-info-block">
		<div class="card-content-title">
			<b translate>eoffer.wizard.header.terms.information</b>
			</div>
		<div class="card-content-block-col-4">
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.currency</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.currency">
						{{displayedOfferHeader.currency}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.interpretation.delivery.date</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.idd">{{displayedOfferHeader.idd}}
					</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.pricing.unit</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.priceUnit">
						{{displayedOfferHeader.priceUnit}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.weightAndInvoicing</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.weightAndInvoicing">
						{{displayedOfferHeader.weightAndInvoicing}}</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.incoterms</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.incoterm">
						{{displayedOfferHeader.incotDescription}}</div>
				</div>
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.paymentTerms</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.paymentTerms">
						{{displayedOfferHeader.paymentTerms}}</div>
				</div>
			</div>
			<div class="card-contents-infos">
				<div class="card-content-info">
					<div class="card-content-label" translate>eoffer.transport.mode</div>
					<div class="card-content-value" [matTooltip]="displayedOfferHeader.tmode">
						{{displayedOfferHeader.tmode}}</div>
				</div>
			</div>
		</div>
	</div>
	<ng-container *ngIf="((displayedOfferHeader && (displayedOfferHeader.validityDate !== '───' || 
			displayedOfferHeader.period !== '───' || (productsFamilies && productsFamilies.length > 0) || 
			displayedOfferHeader.manager !== '───' || displayedOfferHeader.assistant !== '───' ||
			displayedOfferHeader.technician !== '───')))">
		<div class="grid-column-one-full card-info-block">
			<div class="card-block-3">
				<div class="card-infos-block">
					<div class="card-infos">
						<div class="card-info">
							<div class="card-info-label" translate>eoffer.header.offer.validity.date&nbsp;</div>
							<div class="card-info-value" [matTooltip]="displayedOfferHeader.validityDate">{{displayedOfferHeader.validityDate}}</div>
						</div>
						<div *ngIf="displayedOfferHeader.period !== '───'" class="card-info commitment-period">
							<span class="card-info-label card-info-commitment-period" translate>eoffer.header.commitment.period&nbsp;</span>
							<ng-container *ngIf="isSelected !== 'Otherpcp'">
								<span class="card-info-value card-info-commitment-period" [matTooltip]="displayedOfferHeader.period">{{displayedOfferHeader.period}} [ {{isSelected }} {{isSelectedMQSY}}/{{periodStartYear}} ]</span>
							</ng-container>
							<ng-container *ngIf="isSelected === 'Otherpcp'">
								<span class="card-info-value card-info-commitment-period" [matTooltip]="displayedOfferHeader.period">{{displayedOfferHeader.period}}</span>
							</ng-container>
						</div>
					</div>
					<div *ngIf="productsFamilies" class="card-infos">
						<ng-container *ngFor="let productsFamily of productsFamilies">
							<div class="card-info-2">
								<span class="copo-offer-product-family-details">{{productsFamily.productFamilyCategory}} ({{productsFamily.noOfProducts}})  {{productsFamily.form}}</span>
								<span class="copo-offer-total-quantity">{{productsFamily.quantity }}&nbsp;t</span>
								<span class="copo-offer-total-label" translate>eoffer.header.total</span>
							</div>
						</ng-container>
					</div>
				</div>
				<div *ngIf="(displayedOfferHeader.manager !== '───' && displayedOfferHeader.assistant !== '───' && displayedOfferHeader.technician !== '───')" class="card-contents-infos">
					<div class="card-content-info card-contacts">
						<div class="contact-icon">
							<mat-icon class="icon-size" svgIcon="contact"></mat-icon>
						</div>
						<div class="card-info-label-contacts" translate>eoffer.header.commercial.contacts</div>
						<div class="card-info-contacts-value" [matTooltip]="displayedOfferHeader.manager">{{displayedOfferHeader.manager}}</div>
						<div class="card-info-contacts-assistant" [matTooltip]="displayedOfferHeader.assistant">{{displayedOfferHeader.assistant}}</div>
					</div>
					<div class="card-content-info card-contacts">
						<div class="contact-icon">
							<mat-icon class="icon-size" svgIcon="contact"></mat-icon>
						</div>
						<div class="card-info-label-tech-contacts" translate>eoffer.header.technical.contacts</div>
						<div class="card-info-contacts-value" [matTooltip]="displayedOfferHeader.technician">{{displayedOfferHeader.technician}}</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>